
import {TransportMode} from '../models/transportMode';

export interface ITransportModeService {
    getTransportModes(): Promise<Array<TransportMode>>;
}

export class TransportModeService implements ITransportModeService {
    static $inject = ['$http'];

    constructor(private _$http: angular.IHttpService) {

    }

    getTransportModes(): Promise<Array<TransportMode>> {
        
        return new Promise<TransportMode[]>((resolve, reject) => {
            this._$http.get('/getTransportModes')
                .then((response: angular.IHttpPromiseCallbackArg<any>) => {
                    const transportmodes = response.data.map(s => new TransportMode(s, s));
                    resolve(transportmodes);
                });
        });
    }

    
}

angular.module('deliveryCreate.app').service('transportModeService', TransportModeService);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestList/services/transportModeService.ts
 **/